import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import toast from "react-hot-toast";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { fetchCityData, selectCity, clearCityList } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal, Row } from "react-bootstrap";
// import ExcelFile from "../../assets/Wok.xlsx";
import ExcelFile from "../../assets/excelkhoj/Institute candidates Bulk Upload Sample.xlsx";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { fetchLanguage } from "../../redux/actions/LanguageAction";


function EditCard() {
	const sessionId = localStorage.getItem("sessionId");
	// ...............................PROFILE Start.......................................
	// State variables
	const navigate = useNavigate();
	const [displays, setDisplays] = useState(false);
	const [langValue, setLangValue] = useState("");
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [phonenum, setPhonenum] = useState("");
	const [address, setAddress] = useState("");
	const [startDate, setStartDate] = useState("");
	const [headLine, setHeadLine] = useState("");
	const [website, setWebsite] = useState("");
	const [about, setAbout] = useState("");
	const [batch, setBatch] = useState("");
	const [profileImage, setProfileImage] = useState(null);
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);

	//************************Batch Get Start  ************************//
	const [selectedBatch, setSelectedBatch] = useState(null);
	console.log("selectedBatch", selectedBatch);

	const [selectedClass, setSelectedClass] = useState(null);
	const [selectedClassForBulk, setSelectedClassForBulk] = useState(null);
	console.log("selectedClass", selectedClass);

	const [batchList, setBatchList] = useState("")
	const [ClassList, setClassList] = useState("");
	// console.log("setSelectedBatch", setSelectedBatch);
	const [selectedBatches, setSelectedBatches] = useState([]);
	const [batchName, setBatchName] = useState(null);
	const [genderValue, setGenderValue] = useState(null);
	const [city, setCity] = useState(null);
	
	const [unAuthorizeError, setUnAuthorizeError] = useState("");
	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);

	const [fileName, setFileName] = useState("");
	const [selectedFile, setSelectedFile] = useState(null);
	const [showBulkModal, setShowBulkModal] = useState(false);


	const GetCandidateClass = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Class",
		};
		console.log("class data", data);

		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Class data", response.data.responseData);
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setClassList(data);
				console.log("setClassList", data);


			})
			.catch((error) => {
				console.log(error);
				if (error.response && error.response.status === 409) {
					// toast.error(err.response.data.message);
					console.error("Unexpected error:", error);
					setUnAuthorizeError(error.response.data.message)
					handleunauthModal()
				} else {
					console.error("Unexpected error:", error);

				}
			});
	};
	useEffect(() => {
		GetCandidateClass();
	}, []);

	const GetCandidateBatch = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Batch",
		};
		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Batch data=====>", response.data.responseData);
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setBatchList(data);
				console.log("setBatchList", data);

			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		GetCandidateBatch();
	}, []);

	//************************Batch Get End  ************************//

	// Handle Profile Image Change
	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};

	// .......................... Edit-Card Disabled and Enabaled
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleFieldChange = (setter, value) => {
		console.log("value", value);
		setter(value);
		// setFormChanged(true);
		// checkFormValidity()
	}

	useEffect(() => {
		const isValid =
			email &&
			firstName &&
			lastName &&
			phonenum &&
			genderValue &&
			city &&
			startDate &&
			selectedBatches.length > 0 &&
			selectedClass
	
		setFormChanged(isValid);
	}, [email, firstName, lastName,phonenum, genderValue, city, startDate,selectedBatches,selectedClass]);
	
	// Function to check if all required fields are filled
	// const checkFormValidity = () => {
	// 	const isValid =
	// 		email &&
	// 		firstName &&
	// 		lastName &&
	// 		// langValue &&
	// 		genderValue &&
	// 		city &&
	// 		startDate

	// 	// Update the formChanged state based on the validity of all fields
	// 	setFormChanged(isValid);
	// };
	// ..............................  Edit-Card Disabled and Enabaled

	// Common Function to handle both API calls
	// console.log("abouttt" , about);

	// .............................. Bulk upload excel file  Enabled 
	const [formChangedBulk, setFormChangedBulk] = useState(false); // Track if form is modified
	const [isSubmittingBulk, setIsSubmittingBulk] = useState(false);
	const [uploadedFile, setUploadedFile] = useState(null); // Track uploaded file

	// Handle changes and mark form as modified
	const handleFieldChangeBulk = (setter, value, fieldName) => {
		setter(value);
		// setFormChanged(true); 
		// validateForm(fieldName, value);
		if (fieldName === "fileUpload") {
			handleFileUpload(value);
		} else {
			validateForm(fieldName, value);
		}
	};

	// Function to check if all required fields are filled
	const validateForm = (fieldName, value) => {
		const updatedClassId = fieldName === "companyAssoListId" ? value : selectedClassForBulk;
		const updatedFile = fieldName === "fileUpload" ? value : uploadedFile;

		if (updatedClassId && updatedFile) {
			setFormChangedBulk(true);
		} else {
			setFormChangedBulk(false);
		}
	};

	useEffect(() => {
		if (!showBulkModal) {
			// Modal is closing: Reset states
			setSelectedClassForBulk("");
			setUploadedFile(null);
			setFileName("");
			setSelectedFile(null);
			setFormChangedBulk(false);
		}
	}, [showBulkModal]);

	// .............................. Bulk upload excel file  Disabled 



	const Profile = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			setIsSubmitting(true); // Disable the button during submission
			if (
				// langValue &&
				firstName &&
				lastName &&
				phonenum &&
				//headLine &&
				genderValue &&
				city &&
				startDate &&
				profileImage !== ""
			) {
				const batchIds = selectedBatches.map((batch) => batch.value).join(","); // "2,5,13"
				const batchNames = selectedBatches.map((batch) => batch.label).join(","); // "test2,BatchTest,java22"

				// Create FormData for the profile submission
				const formData = new FormData();
				formData.append("LangId", 2);
				formData.append("Email", email);
				formData.append("FirstName", firstName);
				formData.append("LastName", lastName);
				// formData.append("BtchID", Array.isArray(selectedBatch) ? selectedBatch.join(",") : selectedBatch);
				formData.append("BtchID", batchIds);
				// formData.append("BtchID", batchNames);
				// formData.append("BtchID", batchIDs.join(","));
				formData.append("ClssID", selectedClass === null ? null : selectedClass);
				formData.append("GenderId", genderValue);
				formData.append("PhoneNumber", phonenum);
				formData.append("CityId", city);
				formData.append(
					"Dob",
					startDate ? moment(startDate).format("YYYY-MM-DD") : ""
				);
				formData.append("ProfileImage", profileImage);
				formData.append("HeadLine", headLine);
				formData.append("Website", website);
				formData.append("Address", address);
				formData.append("About", about);
				formData.append("SessionId", sessionId);

				console.log("Profile FormData:", formData);

				// First API call to submit the profile data
				const res = await axios.post("/Candidate/AddByInstt", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});

				console.log("Profile Response:", res);
				toast.success(res.data.message);
				setEmail("");
				setFirstName("");
				setLastName("");
				setAddress("");
			    setAddress("");
				setLangValue("");
				setStartDate("");
				setCity("");
				setGenderValue("");
				setHeadLine("");
				setWebsite("");
				setAbout("");
				setProfileImage("");
				setProfileImageview("");
				setDisplays(false);
				navigate("/Institute/Candidate/All");
				setFormChanged(false); // Disable the button after successful update
			} else {
				toast.error("Please enter all required fields!");
			}
		} catch (error) {
			if (error.response.status === 400) {
				toast.error(error.response.data.message)
			} else {
				toast.error(error.response.message);
			}
			console.error(error)
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};

	// ...............................PROFILE End.......................................

	// ...............................Gender DDL.......................................


	const dispatch = useDispatch();
	const { genderOptions, selectedGender } = useSelector(
		(state) => state.gender
	);
	useEffect(() => {
		dispatch(fetchGenders());
	}, [dispatch]);
	const handleGenderSelect = (selectedOption) => {
		if (selectedOption) {
			setGenderValue(selectedOption.value);
		}
		else {
			setGenderValue(null);
		}
	};
	// ...............................Gender DDL.......................................
	// ...............................City DDL.......................................


	const { cityList, selectedcityId } = useSelector((state) => state.cities);
	useEffect(() => {
		dispatch(fetchCityData());
		return () => {
			dispatch(clearCityList()); // Clear cityList when component unmounts
		};
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		console.log("Check input value===>", inputValue)
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			// dispatch(setCity(selectedOption.value));
			setCity(selectedOption.value);
		} else {
			setCity(null);
		}
	};

	// ...............................City DDL.......................................

	// ...............................Language DDL.......................................

	// const [language, setLanguage] = useState([]);
	// const { LanguageList, selectedLanguageId } = useSelector(
	// 	(state) => state.language
	// );
	// console.log("LanguageList", LanguageList);
	// console.log("language", LanguageList);

	// useEffect(() => {
	// 	dispatch(fetchLanguage());
	// }, [dispatch]);

	// useEffect(() => {
	// 	if (userDataInfo && userDataInfo.langIDs && userDataInfo.languages) {
	// 		// 1. Combine langIDs and languages into { value, label } objects
	// 		const combinedLanguages = userDataInfo.langIDs.map((id, index) => ({
	// 			value: id,
	// 			label: userDataInfo.languages[index] // Assuming the arrays are aligned by index
	// 		}));
	// 		// console.log("CombineLanguages===>",combinedLanguages)
	// 		setLanguage(combinedLanguages);
	// 	}
	// }, [LanguageList, userDataInfo]);
	// const handleLanguageSelect = (selectedOption) => {
	// 	if (selectedOption) {
	// 		setLangValue(selectedOption.value); // Set selected value
	// 	} else {
	// 		setLangValue(null);
	// 	}
	// };
	// const handleLanguageSelect = (selectedOption) => {
	// 	console.log("Selected Language===>", selectedOption)
	// 	if (selectedOption) {
	// 		setLanguage(selectedOption);
	// 	} else {
	// 		setLanguage(null);
	// 	}

	// 	setLanguage(selectedOption);
	// 	setFormChanged(true); // Enable the Update button
	// };
	// const multiLang = Array.isArray(language) ? language.map((option) => option.value).join(",") : "";
	// console.log("multiLang", multiLang);

	// ...............................Language DDL.......................................


	const handleShowBulkModal = () => setShowBulkModal(true);

	const handleCloseBulkModal = () => {
		setShowBulkModal(false);
		setSelectedFile(null);
		setFormChangedBulk(false);	
	    setSelectedClassForBulk("");
	    setUploadedFile(null);
	    setFileName("");
	
	
	};

	const downloadExcel = () => {
		const link = document.createElement("a");
		link.href = ExcelFile;
		link.download = fileName;
		link.click();
	};

	const handleFileUpload = (e) => {
		const file = e.target.files[0];
		setUploadedFile(file);
		validateForm("fileUpload", file);
		if (file) {
			setFileName(file.name);
			setSelectedFile(file);
		}
	};

	// const uploadFile = () => {
	// 	setIsSubmittingBulk(true)
	// 	const body = {
	// 		sessionId: sessionId,

	// 	};
	// 	console.log("body", body);

	// 	if (
	// 		""
	// 	) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmittingBulk(false); // Re-enable the button if validation fails
	// 	} else if ("") {
	// 		toast.error("Maximum Salary cannot be less than Minimum Salary");
	// 		setIsSubmittingBulk(false);
	// 	}


	// 	if (!selectedFile) {
	// 		alert("Please select a file to upload!");
	// 		return;
	// 	}
	// 	const formData = new FormData();
	// 	formData.append("file", selectedFile);
	// 	formData.append("file", selectedFile);
	// 	formData.append("file", selectedFile);
	// 	formData.append("file", selectedFile);

	// 	console.log("Uploading file:", selectedFile.name);


	// 	fetch("/Candidate/AddBulkCnddtByInstt", {
	// 	  method: "POST",
	// 	  body: formData,
	// 	})
	// 	  .then((response) => response.json())
	// 	  .then((data) => {
	// 		console.log("File uploaded successfully:", data);
	// 	  })
	// 	  .catch((error) => {
	// 		console.error("Error uploading file:", error);
	// 	  });

	// };

	// const uploadFile = () => {
	// 	setIsSubmittingBulk(true);

	// 	// Ensure required fields are provided
	// 	if (!selectedFile || !sessionId || !selectedClassForBulk) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmittingBulk(false);
	// 		return;
	// 	}

	// 	// Create FormData object
	// 	const formData = new FormData();
	// 	formData.append("ClsID", selectedClassForBulk); // Use selected class value
	// 	formData.append("SessionId", sessionId); // Use session ID
	// 	formData.append("File", selectedFile); // Append the file

	// 	console.log("Uploading file:", selectedFile.name);

	// 	// Send API request
	// 	fetch("/Candidate/AddBulkCnddtByInstt", {
	// 		method: "POST",
	// 		body: formData,
	// 		headers: {
	// 			Authorization: `Bearer ${localStorage.getItem("token")}`, // Add token if required
	// 		},
	// 	})
	// 	.then((response) => response.json())
	// 	.then((data) => {
	// 		console.log("File uploaded successfully:", data);
	// 		toast.success("File uploaded successfully!");
	// 		setIsSubmittingBulk(false);
	// 	})
	// 	.catch((error) => {
	// 		console.error("Error uploading file:", error);
	// 		toast.error("Error uploading file");
	// 		setIsSubmittingBulk(false);
	// 	});
	// };
	const [duplicateSkip, setDuplicateSkip] = useState(false);
	const [isDownloading, setIsDownloading] = useState(false);

	const uploadFile = async (e) => {
		e.preventDefault();
		setIsDownloading(true);
		try {
			// setDisplays(true);
			setIsSubmitting(true); // Disable the button during submission
			{
				const formData = new FormData();
				formData.append("ClssID", selectedClassForBulk);
				formData.append("File", uploadedFile);
				formData.append("SessionId", sessionId);

				console.log("Profile FormData:", formData);

				// First API call to submit the profile data
				const res = await axios.post(`/Candidate/BulkUploadByInstt?DuplicateSkip=${duplicateSkip}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				console.log("Profile Response:", res);
				toast.success(res.data.message);
				setSelectedFile(null)
				handleCloseBulkModal();
				setIsDownloading(false);
			}
		} catch (error) {
			if (error.response.status === 400) {
				toast.error(error.response.data.message)
				setIsDownloading(false);
			} else {
				toast.error(error.response.data.message);
				setIsDownloading(false);
			}
			console.error(error)
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};



	const handleclassType = (selectedOption) => {
		console.log('selectedOption', selectedOption);

		if (selectedOption) {
			// dispatch(selectSalaryType(selectedOption.value));
			setSelectedClass(selectedOption.value);
		} else {
			setSelectedClass(null);

		}
	};


	const handleChange = (selectedOptions) => {
		if (!selectedOptions || selectedOptions.length === 0) {
			setSelectedBatches([]);
			setBatchName([]);
			setSelectedBatch([]);
		} else {
	
		setSelectedBatches(selectedOptions);

		// Extract batchId and batchName separately
		const batchIds = selectedOptions.map((batch) => batch.value);
		const batchNames = selectedOptions.map((batch) => batch.label);
		setBatchName(batchNames)
		setSelectedBatch(batchIds)
		console.log("Batch IDs:", batchIds);
		console.log("Batch Names:", batchNames);
		}
	};

	const handleToggle = (e) => {
		setDuplicateSkip(e.target.checked);
	};

	return (
		<>
			<div className="main-container settings">
				<div className="content-wrapper">
					<div className="title delete-title d-flex justify-content-between Title-header-Mobile manage-drop-section">
						<h1 className="orange-title">
							{" "}
							<span className="orange-box me-1"></span> Add Candidate
						</h1>
						<Button className="mainBtn apply-job ms-2 py-0 bulk-upload-btn"
							onClick={() => {
								handleShowBulkModal()
							}}>
							Bulk upload
						</Button>
					</div>

					<div className="card delete-card EditCard d-flex align-center">
						<div className="post-job-details-form Edit-Card-details-form ">
							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="type">
										Class <span className="text-red">*</span>
									</label>
									<ReactSelect
										// options={ClassList}
										options={Array.isArray(ClassList) ? ClassList : []} 
										// onChange={handleclassType}
										onChange={(option) => handleFieldChange(setSelectedClass, option ? option.value : "")} // Track changes
										// value={selectedClass}
										placeholder="Select class"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control  Dark-Input-from-group"
										isClearable

									/>
									{displays && !selectedClass ? (
										<span className="error_msg_lbl text-red">
											Select Class{" "}
										</span>
									) : null}
								</div>

								<div className="post-form-group">
									<label htmlFor="type">Batch <span className="text-red">*</span></label>
									<ReactSelect
										// options={batchList}
										options={Array.isArray(batchList) ? batchList : []} 
										// onChange={setSelectedBatch}
										// onChange={(option) => handleFieldChange(setSelectedBatch, option ? option.value : "")}
										value={selectedBatches}
										onChange={handleChange}
										placeholder="Select batch"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control  Dark-Input-from-group"
										isMulti
										isClearable
									/>
									{displays && !selectedBatches ? (
										<span className="error_msg_lbl text-red">
											Select Batch{" "}
										</span>
									) : null}
								</div>

							</div>
							<div className="post-form-row">
								<div className="post-form-group text-transform-email">
									<label htmlFor="category ">
										Email <span className="text-red">*</span>
									</label>
									<input
										type="email"
										id="tag"
										placeholder="Email"
										// onChange={(e) => setEmail(e.target.value)}
										onChange={(e) => handleFieldChange(setEmail, e.target.value)}
										value={email}
										invalid={displays && email === ""}
										className="Normal-Input-Fill"
									/>
									{displays && !email ? (
										<span className="error_msg_lbl text-red">Enter Email </span>
									) : null}
								</div>

								 
                               <div className="post-form-group">
									<label htmlFor="type">
										Phone Number <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										maxLength={10}
										placeholder="Enter phone number"
										// onChange={(e) => setFirstName(e.target.value)}
										onChange={(e) => handleFieldChange(setPhonenum, e.target.value)}
										value={phonenum}
										invalid={displays && phonenum === ""}
										className="Normal-Input-Fill"
									/>
									{displays && !phonenum ? (
										<span className="error_msg_lbl text-red">
											Enter Phone Number{" "}
										</span>
									) : null}
								</div>

								
							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="type">
										First Name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										placeholder="Enter first name"
										// onChange={(e) => setFirstName(e.target.value)}
										onChange={(e) => handleFieldChange(setFirstName, e.target.value)}
										value={firstName}
										invalid={displays && firstName === ""}
										className="Normal-Input-Fill"
									/>
									{displays && !firstName ? (
										<span className="error_msg_lbl text-red">
											Enter First Name{" "}
										</span>
									) : null}
								</div>

								<div className="post-form-group">
									<label htmlFor="tag">
										Last Name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										placeholder="Enter last name"
										className="Normal-Input-Fill"
										required
										// onChange={(e) => setLastName(e.target.value)}
										onChange={(e) => handleFieldChange(setLastName, e.target.value)}
										value={lastName}
										invalid={displays && lastName === ""}
									/>
									{displays && !lastName ? (
										<span className="error_msg_lbl text-red">
											Enter Last Name{" "}
										</span>
									) : null}
								</div>

								
								 

							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="jobApplyEmail">
										DOB <span className="text-red">*</span>
									</label>
									<Flatpickr
										type="number"
										id="jobApplyEmail"
										placeholder="Dob"
										// onChange={(date) => setStartDate(date[0])}
										onChange={(date) => handleFieldChange(setStartDate, date[0])}
										value={startDate}
										invalid={displays && startDate === ""}

										options={{
											maxDate: new Date(new Date())
										}}
									/>
									{displays && !startDate ? (
										<span className="error_msg_lbl text-red">Enter Dob </span>
									) : null}
								</div>

							 
								<div className="post-form-group">
									<label htmlFor="externalUrl">
										City <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={cityList}
										// onChange={handleCitySelect}
										onChange={(option) => handleFieldChange(setCity, option ? option.value : "")} // Track changes
										value={
											cityList.find((option) => option.value === city) || null
										}
										isClearable={true}
										placeholder="Search & select city"
										onInputChange={handleCityInputChange}
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control  Dark-Input-from-group"
									/>

									{displays && !city ? (
										<span className="error_msg_lbl text-red">Search & Select City </span>
									) : null}
								</div>

								

							</div>

							<div className="post-form-row">

                                <div className="post-form-group">
									<label htmlFor="jobApplyType">
										Gender <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={genderOptions}
										// onChange={handleGenderSelect}
										onChange={(option) => handleFieldChange(setGenderValue, option ? option.value : "")} // Track changes
										value={
											genderOptions.find(
												(option) => option.value === genderValue
											) || null
										}
										placeholder="Select gender"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control  Dark-Input-from-group"
										isClearable={true}
									/>
									{displays && !genderValue ? (
										<span className="error_msg_lbl text-red">
											Select Gender{" "}
										</span>
									) : ""}
								</div>

								<div className="post-form-group profile-image-style">
									<div className="post-form-group">
									<label htmlFor="ProfileImg">Profile Image</label>
									<input
										type="file"
										id="ProfileImg"
										className="form-control Dark-Input-from-group"
										required
										accept="image/jpeg, image/png, image/jpg"
										// onChange={handleProfileImageChange}
										onChange={(e) => {
											handleFieldChange(setProfileImage, e.target.files[0]);
											setProfileImageview(URL.createObjectURL(e.target.files[0]));
										}}
										style={{ height: '56px', paddingTop: '15px' }}
									/>
									{error && <span className="error_msg_lbl text-red">{error}</span>}

									</div>
									 
								{profileImageview && (
									<img
										src={profileImageview}
										alt="Profile Preview"
										width={100}
										// height={120}
										className="mt-2"
										// style={{ borderRadius: '50%' }}
									/>
								)}
								</div>

							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="minSalary">
										HeadLine 
									</label>
									<input
										type="text"
										id="minSalary"
										placeholder=" Enter headLine"
										required
										// onChange={(e) => setHeadLine(e.target.value)}
										onChange={(e) => handleFieldChange(setHeadLine, e.target.value)}
										value={headLine}
										invalid={displays && headLine === ""}
										className="Normal-Input-Fill"
									/>
									{/* {displays && !headLine ? (
										<span className="error_msg_lbl text-red">
											Enter Headline{" "}
										</span>
									) : null} */}
								</div>
								<div className="post-form-group text-transform-email">
									<label htmlFor="experience">Website </label>
									<input
										type="text"
										id="website"
										placeholder="Enter website"
										// onChange={(e) => setWebsite(e.target.value)}
										onChange={(e) => handleFieldChange(setWebsite, e.target.value)}
										value={website}
										invalid={displays && website === ""}
										className="Normal-Input-Fill"
									/>
									{/* {displays && !website ? (
										<span className="error_msg_lbl text-red">
											Write Web Name{" "}
										</span>
									) : null} */}
								</div>
							</div>

                            <div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="maxSalary">Address</label>
									<textarea
									style={{height: '70px'}}
										type="text"
										rows={2}
										id="maxSalary"
										placeholder="Enter Address"
										// onChange={(e) => setAbout(e.target.value)}
										onChange={(e) => handleFieldChange(setAddress, e.target.value)}
										value={address}
										invalid={displays && address === ""}
										className="Normal-Input-Fill "
									/>
									{/* {displays && !about ? (
										<span className="error_msg_lbl text-red">Write About </span>
										) : null} */}
								</div>
							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="maxSalary">About</label>
									<textarea
										type="text"
										id="maxSalary"
										placeholder="Enter about"
										// onChange={(e) => setAbout(e.target.value)}
										onChange={(e) => handleFieldChange(setAbout, e.target.value)}
										value={about}
										invalid={displays && about === ""}
										className="Normal-Input-Fill "
									/>
									{/* {displays && !about ? (
										<span className="error_msg_lbl text-red">Write About </span>
										) : null} */}
								</div>
							</div>

							<div className="avatar-upload-container">
								<div className="avatar-upload-section"></div>
								<button
									//  className="save-button"
									// onClick={(e) => Profile(e)}
									// disabled={!formChanged}
									onClick={Profile}
									className={`btn btn-primary mainBtn apply-job mb-3 mt-2 ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
									// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
									disabled={!formChanged || isSubmitting}
									style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
								>
									Save Profile
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>


			<Modal show={showBulkModal}
				onHide={handleCloseBulkModal}
				size="md" centered
				className="Bulk-Upload-Excel-Modal"
			>
				<Modal.Header >
					<Modal.Title>Bulk upload excel file</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseBulkModal} />
				</Modal.Header>

				<Modal.Body>
					<div className="row">
						<div className="col-md-12">
							<div className="post-form-group">
								<label htmlFor="type">
									Class <span className="text-red">*</span>
								</label>
								<ReactSelect
									// options={ClassList}
									options={Array.isArray(ClassList) ? ClassList : []} 
									// onChange={handleclassType}
									onChange={(option) => handleFieldChangeBulk(setSelectedClassForBulk, option ? option.value : "", "companyAssoListId")} // Track changes
									// value={selectedClass}
									placeholder="Select Class"
									styles={customStyles}
									classNamePrefix="react-select"
									className="form-control  Dark-Input-from-group"
									isClearable

								/>
								{displays && !selectedClassForBulk ? (
									<span className="error_msg_lbl text-red">
										Select Class{" "}
									</span>
								) : null}
							</div>
						</div>

					</div>

					<div className="row">
						<div className="col-md-6">
							<div className="pt-3 ">
								<div className="d-flex justify-content-center">
									<input
										type="file"
										accept=".xlsx,.xls"
										onChange={handleFileUpload}
										style={{
											marginTop: "15px",
											// border: "1px solid #ddd",
											padding: "5px 10px",
											borderRadius: "5px",
											cursor: "pointer",
										}}
									/>
								</div>

							</div>
						</div>
						{/* <div className="col-md-6 pt-4  d-flex">
							<h6 className="me-2">Duplicate skip</h6>
							<label class="switch">
								<input
									type="checkbox"
									checked={duplicateSkip}
									// onChange={handleToggle}
									onChange={(e) => handleFieldChangeBulk(setDuplicateSkip, e.target.checked, "duplicateSkip")}
								// defaultChecked={false}
								/>
								<span class="slider round"></span>
							</label>
						</div> */}
						<div className="col-md-6 duplicate-skip-cont d-flex">
							<h6 className="f-700 me-2">Duplicate skip</h6>
							<span>
								<label class="switch">
									<input
										type="checkbox"
										checked={duplicateSkip}
										// onChange={handleToggle}
										onChange={(e) => handleFieldChangeBulk(setDuplicateSkip, e.target.checked, "duplicateSkip")}
									// defaultChecked={false}
									/>
									<span class="slider round"></span>
								</label>
							</span>

						</div>
					</div>

				</Modal.Body>
				<div className="d-flex justify-content-center pe-3 pb-3">
					<div className="add-class-submit-button d-flex justify-content-center">
						<Button variant="secondary" onClick={handleCloseBulkModal}>
							Close
						</Button>

						<div className="khojPrimaryBtn ms-3"
						    onClick={uploadFile}
							style={{ height: "40px", width: "120px" , cursor: formChangedBulk ? "pointer" : "default" }}
						>
							<a href="#/" 
							// onClick={uploadFile}
								className={`btn ${!formChangedBulk || isSubmittingBulk ? "disabled" : "enabled"}`}
								// disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChangedBulk ? "auto" : "none", border: "none" }}
							>
								{/* Upload */}
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</a>
						</div>
						{/* <div className="ms-2">
							<button
								type="button"
								// className="f-500 mt-2 downloadbtn khojPrimaryBtn"
								className={`btn ${!formChangedBulk || isSubmittingBulk ? "disabled" : "enabled"} f-500 mt-2 downloadbtn khojPrimaryBtn`}
								onClick={uploadFile}
								style={{
									width: "120px",
									// opacity: isDownloading ? 0.6 : 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: "6px",
									border: !formChangedBulk || isSubmittingBulk ? "none" : undefined,

								}}

							// disabled={!formChanged || isSubmitting}
							>
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</button>
						</div> */}
					</div>
				</div>
				<hr />
				<div className="d-flex justify-content-center align-items-baseline">

					<p className="text-center mb-2">Download reference file</p>
					<div className="col-md-3">
						<div className="khoDwnlodBtn ms-3">
							{/* <Tooltip title="Download reference file" arrow> */}
							<p onClick={downloadExcel}>
								Download
							</p>
							{/* </Tooltip> */}
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-center">

					{/* <div className="col-md-6 ">
						<div className="Excel-File-Box"
							style={{
								width: "100%",
								padding: "8px",
								border: "1px solid #ddd",
								borderRadius: "8px",
								textAlign: "center",
								backgroundColor: "#f9f9f9",
								marginBottom: "15px",
							}}
						>
							<p style={{ margin: "0", fontWeight: "bold" }}>Wok.xlsx</p>
						</div>
					</div> */}

				</div>
			</Modal>

			{/* ...............UnAuthorize modal............  */}
			{unAuthorizeError ? (
				<Modal show={unauthModal} centered>
					<Modal.Header>
						<Modal.Title>Unauthorize session expired</Modal.Title>
					</Modal.Header>
					<Modal.Body className="settings">
						<div className=" mb-3">
							<p>{unAuthorizeError}</p>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link
							className="pointer"
							to="/Login"
							onClick={() => {
								localStorage.removeItem("token"); // Remove authentication token
								sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
								localStorage.removeItem("Module");
							}}
						>
							<button className="btn btn-danger ">Login</button>
						</Link>
						{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

					</Modal.Footer>

				</Modal>
			) : (
				""
			)}
		</>
	);
}

export default EditCard;
